import { Button } from '../button/Button';
import { withPersonalizedButtonStyle } from '../button/withPersonalizedButtonStyle';
import { styles } from './TertiaryButton.styles';

export const TertiaryButton = withPersonalizedButtonStyle(Button, styles);
